import React, { Component } from "react";
import { Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import { auth } from "../firebase";

class Navbar extends Component {
	toggleOffcanvas() {
		document.querySelector(".sidebar-offcanvas").classList.toggle("active");
	}
	toggleRightSidebar() {
		document.querySelector(".right-sidebar").classList.toggle("open");
	}
	render() {
		return (
      <nav className='navbar p-0 fixed-top d-flex flex-row' style={{ height: '70px', background: '#ffffff', borderBottom: '1px solid #ebedf2' }}>
        <div className='navbar-brand-wrapper d-flex d-lg-none align-items-center justify-content-center' style={{ background: '#191c24', width: '70px' }}>
          <Link className='navbar-brand brand-logo-mini' to='/'>
            <img src={require("../assets/images/logo.png")} alt='logo' style={{ maxWidth: '20px' }} />
          </Link>
        </div>
        <div className='navbar-menu-wrapper flex-grow d-flex align-items-stretch px-2 px-lg-4'>
          <button
            className='navbar-toggler align-self-center'
            type='button'
            onClick={() => document.body.classList.toggle("sidebar-icon-only")}
          >
            <i className='mdi mdi-menu text-dark' style={{ fontSize: '1.5rem' }}></i>
          </button>
          
          <ul className='navbar-nav navbar-nav-right'>
            <Dropdown alignRight as='li' className='nav-item'>
              <Dropdown.Toggle
                as='a'
                className='nav-link cursor-pointer no-caret px-0'
              >
                <div className='navbar-profile d-flex align-items-center'>
                  <div
                    className='rounded-circle d-flex justify-content-center align-items-center'
                    style={{ width: "40px", height: "40px", border: '1px solid #ebedf2', background: '#f8f9fa' }}
                  >
                    <i
                      style={{ fontSize: "24px" }}
                      className='mdi mdi-account text-primary'
                    ></i>
                  </div>
                  <div className='ml-2 d-none d-sm-block text-left'>
                    <p className='mb-0 font-weight-700 text-dark' style={{ fontSize: '0.85rem', lineHeight: '1.2', color: '#000' }}>
                      {auth.currentUser?.displayName || "My Account"}
                    </p>
                    <p className='mb-0 text-dark' style={{ fontSize: '0.7rem', color: '#000' }}>
                      {auth.currentUser?.email}
                    </p>
                  </div>
                  <i className='mdi mdi-chevron-down ml-2 d-none d-sm-block text-gray-400' style={{ fontSize: '1rem' }}></i>
                </div>
              </Dropdown.Toggle>

              <Dropdown.Menu className='navbar-dropdown preview-list navbar-profile-dropdown-menu shadow-lg border-0 mt-2 rounded-premium animate-in' style={{ minWidth: '220px', background: '#ffffff', padding: '0' }}>
                <div className='dropdown-header py-3 border-bottom' style={{ background: '#f8f9fa', borderTopLeftRadius: '12px', borderTopRightRadius: '12px' }}>
                  <h6 className='p-0 mb-0 font-weight-800 text-dark' style={{ fontSize: '0.85rem' }}>User Profile</h6>
                </div>
                
                <Dropdown.Item
                  href='!#'
                  onClick={(e) => { e.preventDefault(); auth.signOut(); }}
                  className='preview-item py-3 d-flex align-items-center'
                  style={{ background: 'transparent' }}
                >
                  <div className='preview-thumbnail'>
                    <div className='preview-icon bg-gray-100 rounded-circle d-flex align-items-center justify-content-center' style={{ width: '35px', height: '35px' }}>
                      <i className='mdi mdi-logout text-danger' style={{ fontSize: '18px' }}></i>
                    </div>
                  </div>
                  <div className='preview-item-content ml-3'>
                    <p className='preview-subject mb-0 font-weight-600 text-dark' style={{ fontSize: '0.9rem' }}>Log Out</p>
                  </div>
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </ul>
          
          <button
            className='navbar-toggler navbar-toggler-right d-lg-none align-self-center ml-2'
            type='button'
            onClick={this.toggleOffcanvas}
          >
            <i className='mdi mdi-format-indent-increase text-dark' style={{ fontSize: '1.5rem' }}></i>
          </button>
        </div>
      </nav>
		);
	}
}

export default Navbar;
